module.exports = __webpack_public_path__ + "img/Exclude.de2a9ce7.svg";